import { useLocation, useNavigate } from "react-router-dom";
import HomeScrollPicFragment from "../../components/dashboard/HomeScrollPicFragment";
import UserFeedCard from "../../components/dashboard/UserFeedCard";
import { AppPaths } from "../../utils/AppPaths";
import HomeScrollQuizFragment from "../../components/dashboard/HomeScrollQuizFragment";
import { useEffect, useState } from "react";
import ApiService from "../../api/ApiServices";
import LoadImage from '../../assets/loader.gif';

const FallFunQuizChallange = () => {
  const navigation = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const [load, setLoad] = useState<boolean>(false)
  const [loadMore, setLoadMore] = useState<boolean>(false)
  const [quizData, setQuizData] = useState<any>(null)
  const [challengeData, setChallengeData] = useState<any>(null)
  const [pagination, setPagination] = useState<any>({
    totalItems: 0,
    totalPages: 1,
    currentPage: 1,
    limit: 10,
  })
  const [currentPage, setCurrentPage] = useState<number>(1)

  const getQuizData = async (pageNumber: number = 1, isLoadMore: boolean = false) => {
    if (!id) {
      return;
    }

    if (isLoadMore) {
      setLoadMore(true);
    } else {
      setLoad(true);
    }

    const response = await ApiService.getQuizById(id, pageNumber, 10);

    if (pageNumber === 1) {
      const responseChallange = await ApiService.getChallengeById(id);
      setChallengeData(responseChallange?.data);
    }

    setQuizData((prev: any) => {
      if (pageNumber === 1 || !prev) {
        return response?.data;
      }

      return {
        ...response?.data,
        feeds: [...(prev?.feeds || []), ...(response?.data?.feeds || [])],
      };
    });

    setPagination(response?.pagination || {
      totalItems: 0,
      totalPages: 1,
      currentPage: pageNumber,
      limit: 10,
    });
    setCurrentPage(pageNumber);

    if (response?.data?.challenges?.metadata?.isUrl && pageNumber === 1) {
      window.open(response?.data?.challenges?.metadata?.url, '_blank')
    }

    if (isLoadMore) {
      setLoadMore(false);
    } else {
      setLoad(false);
    }
  }

  const onLoadMore = () => {
    if (loadMore || currentPage >= (pagination?.totalPages || 1)) {
      return;
    }

    getQuizData(currentPage + 1, true);
  }

  useEffect(() => {
    if (id) {
      setQuizData(null);
      setChallengeData(null);
      setPagination({
        totalItems: 0,
        totalPages: 1,
        currentPage: 1,
        limit: 10,
      });
      setCurrentPage(1);
      getQuizData(1)
    }
  }, [id])
  return (
    <>
      {load ? <div className="flex justify-center items-center h-screen mb-5">
        <img width="100px" className="center" src={LoadImage} alt="loader" />
      </div> : <div className="flex flex-col relative pb-20 mx-1 pt-3">
        <div className="flex flex-1 flex-row mx-3 items-center relative">
          <div>
            <img
              onClick={() => {
                navigation(AppPaths.MYJOURNEY);
              }}
              alt=""
              className="home-frag-pic-backbtn mr-2 cursor-pointer"
              src={require("../../assets/arrow-left.png")}
            />
          </div>
          <div className="btn-onb4-text absolute left-1/2 -translate-x-1/2 text-center">{challengeData?.challenges?.title}</div>
        </div>
        <div className="py-5 mx-3 flex flex-col">
          <HomeScrollQuizFragment
            id={challengeData?.challenges?._id}
            picUrl={challengeData?.challenges?.metadata?.thumbnail}
            imgStyle={"challange-frag-img"}
            noMore
            contStyle={`overflow-hidden challange-frag-img-cont `}
            onCompleted={() => getQuizData(1)}
          />
        </div>
        <div className="inter-bold-text-16 px-3 flex items-center">
        {challengeData?.challenges?.houseName} House Responses
        <img
          src={challengeData?.challenges?.image}
          height="16"
          width="16"
          style={{ paddingTop: "3px", marginLeft: "5px" }}
          alt="diamond"
        />
      </div>
        {/* <div className="flex flex-1 flex-row items-center mx-3">
          <span className="bg-black h-0.5 flex flex-1"></span>
          <span className="flex flex-row items-center mx-2">
            <img
              src={quizData?.challenges?.image ? quizData?.challenges?.image : require("../../assets/placeholder_gem.png")}
              alt=""
              className="header-jem-sm mr-1"
            />
            <div className="inter-14-bold ">{quizData?.challenges?.points}&nbsp;pts</div>
          </span>
          <span className="bg-black h-0.5 flex flex-1"></span>
        </div> */}
        <div className=" flex flex-1 flex-col">
          {quizData?.feeds?.map((item: any) => {
            return <UserFeedCard key={item?._id} type="quiz" data={item} />
          })}
        </div>
        {currentPage < (pagination?.totalPages || 1) && (
          <div className="flex justify-center mt-4">
            <div
              onClick={onLoadMore}
              className="btn-onb4-text underline underline-offset-4 cursor-pointer"
            >
              {loadMore ? "Loading..." : "Load More"}
            </div>
          </div>
        )}
      </div>}
    </>
  );
};

export default FallFunQuizChallange;
